import { Pipe, PipeTransform } from '@angular/core';
import { FilterItem } from 'app/shared/models/filter-group.models';

@Pipe({
    name: 'checkRange',
    standalone: false
})

export class CheckRangePipe implements PipeTransform {
  public transform(data: FilterItem[]): boolean {
    let result = false;
    data.forEach(element => {
      if (element.value) {
        result = true;
      }
    });
    return result;
  }
}
